module.exports = __webpack_public_path__ + "media/step7_Kernaufgaben_animation.29a8d1ed.webm";